"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GhostBackgroundContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const HalfGhost_svg_1 = __importDefault(require("../../images/HalfGhost.svg"));
const GhostBackgroundContainer_module_css_1 = __importDefault(require("./GhostBackgroundContainer.module.css"));
/**
 * A simple that centers its child content with a Ghost background
 */
function GhostBackgroundContainer({ children, }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: `${GhostBackgroundContainer_module_css_1.default.centered} ${GhostBackgroundContainer_module_css_1.default.container}`, children: [(0, jsx_runtime_1.jsx)("span", { className: GhostBackgroundContainer_module_css_1.default.half, children: (0, jsx_runtime_1.jsx)(HalfGhost_svg_1.default, {}) }), (0, jsx_runtime_1.jsx)("div", { className: GhostBackgroundContainer_module_css_1.default.content, children: children })] }));
}
exports.GhostBackgroundContainer = GhostBackgroundContainer;
//# sourceMappingURL=GhostBackgroundContainer.js.map